module.exports = __webpack_public_path__ + "img/logo_procu.add7d431.svg";